import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiAIProcessingStatus } from "@/types/ai/ai.types.ts";
import { ApiCandidate } from "@/types/recruit/applicant.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { Button, Stack, Tag, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface CandidateAIScoreNAProps {
  handleCalculate: () => Promise<void>;
  isCalculateLoading: boolean;
  candidate: ApiCandidate;
}

export function CandidateAIScoreNA({
  handleCalculate,
  isCalculateLoading,
  candidate,
}: CandidateAIScoreNAProps) {
  const { canIEdit } = usePermissions();
  const { t } = useTranslation();

  const title =
    candidate.ai_score_status == ApiAIProcessingStatus.waiting
      ? t("ai:match_not_calculated")
      : t("ai:calculation_failed");
  const caption =
    candidate.ai_score_status == ApiAIProcessingStatus.waiting
      ? t("ai:request_calculate")
      : t("ai:calculation_failed_description");

  return (
    <Stack
      gap={"md"}
      justify={"between"}
      direction={"horizontal"}
      items={"center"}
      className={"py-4 border-b border-dark/10"}
    >
      <Stack direction={"horizontal"} items={"center"} gap={"sm"}>
        <Tag size={"xl"} appearance={"filled"} square={true} glow={true} variant={"secondary"}>
          {t("common:n_a")}
        </Tag>
        <Title header={title} caption={caption} />
      </Stack>

      {canIEdit(ApiPermission.manage_candidates) && (
        <Button onClick={handleCalculate} variant={"secondary"} isLoading={isCalculateLoading}>
          {t("ai:calculate")}
        </Button>
      )}
    </Stack>
  );
}
